import {
	Box,
	Container,
	FormControlLabel,
	Switch,
} from "@material-ui/core";
import axiosWrapper from "common/axiosWrapper";
import { SetLoading } from "common/components/Loader/Loader";
import SettingsHelper from "common/helpers/settingsHelper";
import * as React from "react";
import { Helmet } from "react-helmet";

const SETTING_NAME = "ShowMobileRedirectDialog";

export default function MobileSettings() {
	const [enabled, setEnabled] = React.useState(false);
	const [ready, setReady] = React.useState(false);

	React.useEffect(() => {
		SettingsHelper.getSetting(SETTING_NAME).then((value) => {
			setEnabled(value === true);
			setReady(true);
		});
	}, []);

	const onToggle = async (e) => {
		const next = e.target.checked;
		setEnabled(next);
		SetLoading(true, "Saving...");
		try {
			await axiosWrapper.put(`api/settings/${SETTING_NAME}`, {
				value: next ? "true" : "false",
			});
			SettingsHelper.settings.set(SETTING_NAME, next);
		} catch (err) {
			setEnabled(!next);
		} finally {
			SetLoading(false);
		}
	};

	return (
		<Container maxWidth="sm">
			<Helmet>
				<title>Pickstop - Mobile Settings</title>
			</Helmet>
			<Box mt={4}>
				<h1>Mobile Settings</h1>
				<Box mt={2}>
					<FormControlLabel
						control={
							<Switch
								checked={enabled}
								onChange={onToggle}
								disabled={!ready}
								color="primary"
							/>
						}
						label="Show 'try the new experience' dialog on mobile devices"
					/>
				</Box>
			</Box>
		</Container>
	);
}
